import { FC, ReactNode } from 'react';

import { FormControl as MaterialFormControl } from '@mui/material';

import './FormControl.scss';

type PropsType = {
    children: ReactNode;
    classes?: string;
};

const FormControl: FC<PropsType> = ({ classes, children }) => {
    const setClasses = typeof classes === 'string' ? classes : '';
    const allClasses = 'fc-form-control ' + setClasses;
    return (
        <MaterialFormControl className={allClasses}>
            {children}
        </MaterialFormControl>
    );
};

export default FormControl;
